import { render, staticRenderFns } from "./NiceCheck.vue?vue&type=template&id=08d023b0&scoped=true&"
import script from "./NiceCheck.vue?vue&type=script&lang=js&"
export * from "./NiceCheck.vue?vue&type=script&lang=js&"
import style0 from "./NiceCheck.vue?vue&type=style&index=0&id=08d023b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d023b0",
  null
  
)

export default component.exports